import classNames from "classnames";
import React from "react";

export type IconName = "home" |
    "home-outline" |
    "bar-chart" |
    "logout" |
    "add" |
    "add-outline" |
    "minus-outline" |
    "playlist" |
    "document" |
    "report" |
    "network" |
    "user" |
    "search" |
    "product" |
    "external-link" |
    "refresh" |
    "sort" |
    "sort-asc" |
    "sort-desc" |
    "download" |
    "down-arrow" |
    "calendar" |
    "info" |
    "next" |
    "previous" |
    "trash" |
    "pencil" |
    "note" |
    "artist" |
    "arrow-right" |
    "add-outline-dark" |
    "minus-outline-dark" |
    "cross";
export type IconSize = "2x" | "sm";
export interface IconProps {
    name?: IconName;
    size?: IconSize;
}

export const WaIcon = ({ name, size }: IconProps) => {
    return <span className={classNames("wa-icon", "wa-" + name, size)}></span>;
};
